/**
 * Floating numbers on the field (slice 8c), read off the sim's events: the HP a battle cost the
 * loser ("-14") over the loser, a heal from drain ("+3"), the winner's type multiplier as the battle
 * used it when it is not 1 ("1.23x", "0.81x"; slice 10a: an attack's is the full chart's, "2x"),
 * colored up or down by the chart's edge, a line above the loser's number, and CRIT over the
 * side that landed one. Pure, so the tests read the same floats the field draws; fx.ts only
 * places and fades them.
 */
import type { PlayEvent, UnitId } from '@tdmons/sim';

export type FloatKind = 'damage' | 'heal' | 'mult-up' | 'mult-down' | 'crit';

export interface Float {
  kind: FloatKind;
  text: string;
  /** The Pokémon it floats over. */
  unit: UnitId;
}

/** "2x", "0.5x", "1.5x", "0.25x": no trailing zeros. */
export const multText = (m: number): string => `${Number(m.toFixed(2))}x`;

export function floatsFor(e: PlayEvent): Float[] {
  if (e.type === 'hp') {
    const n = Math.round(Math.abs(e.delta));
    if (n === 0) return [];
    return [
      e.delta < 0
        ? { kind: 'damage', text: `-${n}`, unit: e.unit }
        : { kind: 'heal', text: `+${n}`, unit: e.unit },
    ];
  }
  if (e.type !== 'battle') return [];
  const m = e.matchup;
  const out: Float[] = [];
  const mult = m.winner === 'a' ? m.aTypeMult : m.bTypeMult;
  const loser = m.winner === 'a' ? e.b : e.a;
  if (mult !== 1) {
    out.push({ kind: mult > 1 ? 'mult-up' : 'mult-down', text: multText(mult), unit: loser });
  }
  if (m.crit !== undefined)
    out.push({ kind: 'crit', text: 'CRIT', unit: m.crit === 'a' ? e.a : e.b });
  return out;
}
